import { useEffect, useRef } from 'react';

export const useBreadcrumbsSizeChange = (breadcrumbRef) => {
  const resizeObserver = useRef(null);

  const fixScrollingHeight = (headerHeight: number) => {
    // when transitioning from normal header to sticky header - scrolling will be incorrect if we dont set up header height
    const headerEl: HTMLDivElement = document.querySelector('.l-header');
    const inPageNav = document.querySelector('.c-in-page-nav');
    const navList = inPageNav && inPageNav.querySelector('.c-in-page-nav-list');
    const hasNavElement = !!(navList && navList.childElementCount > 0);
    const inPageNavHeight = hasNavElement ? 48 : 0;

    headerEl.style.height = `${headerHeight + inPageNavHeight}px`;
  };

  const fitBreadcrumbs = () => {
    // on every breadcrumbs size change - setting header height set by CLS fix to actual height
    const headerWrapperEl: HTMLDivElement = document.querySelector('.l-header-sticky-wrapper');
    const headerMainEl = headerWrapperEl.querySelector('.l-header-sticky');
    const newHeight = headerMainEl.clientHeight;

    headerWrapperEl.style.height = `${newHeight}px`;
    fixScrollingHeight(newHeight);
  };

  useEffect(() => {
    resizeObserver.current = new ResizeObserver(() => {
      fitBreadcrumbs();
    });

    resizeObserver.current.observe(breadcrumbRef.current);

    return () => {
      if (resizeObserver.current) {
        resizeObserver.current.disconnect();
      }
    };
  }, []);
};
